import React, { useState } from 'react'
import apiClient, { API_ENDPOINTS } from '../../config/api'

const CreateCompany = () => {
  const [form, setForm] = useState({
    name: '',
    address: '',
    phone: '',
    email: '',
    small_shop_mode: false,
  })
  const [logo, setLogo] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null
    setLogo(file)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)

    if (!form.name || !form.address || !form.phone || !form.email) {
      setError('Please fill in all required fields.')
      return
    }

    if (!logo) {
      setError('Please upload a company logo.')
      return
    }

    const data = new FormData()
    data.append('name', form.name)
    data.append('address', form.address)
    data.append('phone', form.phone)
    data.append('email', form.email)
    data.append('small_shop_mode', form.small_shop_mode ? 'true' : 'false')
    data.append('logo', logo)

    try {
      setSubmitting(true)
      await apiClient.post(API_ENDPOINTS.BILLING_COMPANIES, data)

      setSuccess('Company created successfully.')
      setForm({
        name: '',
        address: '',
        phone: '',
        email: '',
        small_shop_mode: false,
      })
      setLogo(null)
      // Reset file input element
      if (e.target && e.target.reset) {
        e.target.reset()
      }
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        'Failed to create company. Please try again.'
      setError(msg)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <div className="pagetitle">
        <h1>Create Company</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item">System Admin</li>
            <li className="breadcrumb-item active">Create Company</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-building-add me-2" />
                  Create New Company
                </h5>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                {success && (
                  <div className="alert alert-success" role="alert">
                    {success}
                  </div>
                )}

                <form className="row g-3" onSubmit={handleSubmit}>
                  <div className="col-md-6">
                    <label htmlFor="companyName" className="form-label">Company Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="companyName"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="companyEmail" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="companyEmail"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="companyPhone" className="form-label">Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="companyPhone"
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="companyAddress" className="form-label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      id="companyAddress"
                      name="address"
                      value={form.address}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="companyLogo" className="form-label">Logo</label>
                    <input
                      type="file"
                      className="form-control"
                      id="companyLogo"
                      accept="image/*"
                      onChange={handleFileChange}
                     
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label d-block">Small shop mode</label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="small_shop_mode"
                        name="small_shop_mode"
                        checked={!!form.small_shop_mode}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor="small_shop_mode">
                        Allow only Admin & Cashier roles (unlimited users)
                      </label>
                    </div>
                  </div>

                  <div className="col-12">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={submitting}
                    >
                      {submitting ? 'Creating...' : 'Create Company'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default CreateCompany

